{
  "it": {
    "form": {
      "actions": {
        "cancel": "Annulla",
        "clear": "Svuota",
        "closeFullPage": "Chiudi pagina intera",
        "copyText": "Faccia clic per copiare il testo",
        "create_and_attach_phase": "Crea e collega alla fase",
        "create_and_send": "Crea e invia",
        "create_and_send_to_customer": "Crea e invia al cliente",
        "create_and_share": "Crea e condividi con il cliente",
        "create_and_share_partners_only": "Crea e condividi con i partner",
        "create_and_share_with_partners": "Crea e condividi con cliente e partner",
        "next": "Avanti",
        "only_create": "Crea soltanto",
        "openFullPage": "Apri a pagina intera",
        "save": "Salva",
        "saveChanges": "Salva modifiche",
        "save_as_draft": "Salva come bozza",
        "search": "Cerca...",
        "send": "Invia",
        "send_and_create_another": "Invia e crea un altro",
        "send_to_customer": "Invia al cliente",
        "share_with_customer": "Condividi con il cliente",
        "submit": "Salva",
        "submit_and_create_another": "Salva e crea un altro"
      },
      "back": "Passaggio precedente",
      "labels": {
        "columns": "Colonne",
        "from": "Da",
        "no_results": "Nessun risultato",
        "optional": "(facoltativo)",
        "to": "A"
      },
      "notifications": {
        "textHasBeenCopied": "Il testo è stato copiato"
      },
      "password": "Password",
      "send_moment": {
        "attach_failed": "Creato, ma non collegato alla fase. Lo colleghi di nuovo nel flusso di lavoro.",
        "concept_description": "Nessuno vede niente. Lo invia Lei più tardi, oppure lo collega comunque a una fase.",
        "concept_title": "Salva come bozza",
        "item_decision": "questa decisione",
        "item_survey": "questo questionario",
        "item_todo": "questa attività",
        "now_description_decision": "I clienti delle unità selezionate ricevono subito la decisione, con una notifica.",
        "now_description_survey": "I clienti delle unità selezionate ricevono subito il questionario, con una notifica.",
        "now_description_todo": "I responsabili delle unità selezionate ricevono subito l'attività, con una notifica.",
        "now_title": "Invia ora",
        "phase_description": "Parte da sola per ogni unità appena quell'unità raggiunge la fase.",
        "phase_label": "Fase",
        "phase_title": "Collega a una fase",
        "title": "Quando vedrà il cliente {item}?",
        "workflow_help": "Che cos'è un flusso di lavoro?",
        "workflow_help_more": "Per saperne di più",
        "workflow_help_text": "Un flusso di lavoro sono le fasi che ogni unità attraversa. Se collega qualcosa a una fase, il cliente lo vede automaticamente appena la sua unità raggiunge quella fase."
      },
      "shortcuts": {
        "save_mac": "⌘ + Invio per salvare",
        "save_windows": "Ctrl + Invio per salvare",
        "send_mac": "⌘ + Invio per inviare",
        "send_windows": "Ctrl + Invio per inviare"
      },
      "steps": "Passaggio {count} di {total}",
      "writeEmployeeNameReject": "Scriva <i><b>{employeeName}</b></i> per continuare."
    }
  }
}
